import { Box, FormControl, FormLabel, Icon, SimpleGrid, Text, useColorModeValue } from '@chakra-ui/react';
import { useIntl } from 'react-intl';
import { AbsenceType } from '../../types';
import { IconType } from 'react-icons';
import { MdBeachAccess, MdLocalHospital, MdLocalPharmacy, MdMoneyOff, MdMoreHoriz, MdPersonOff, MdSwapHoriz } from 'react-icons/md';

export const absenceTypeIconMap: Record<AbsenceType, IconType> = {
    [AbsenceType.VACATION]: MdBeachAccess,
    [AbsenceType.SICK_LEAVE]: MdLocalHospital,
    [AbsenceType.DOCTOR]: MdLocalPharmacy,
    [AbsenceType.PERSONAL_LEAVE]: MdPersonOff,
    [AbsenceType.UNPAID_LEAVE]: MdMoneyOff,
    [AbsenceType.COMPENSATORY_LEAVE]: MdSwapHoriz,
    [AbsenceType.OTHER]: MdMoreHoriz,
};

type AbsenceTypePickerProps = {
    value: AbsenceType;
    onChange: (type: AbsenceType) => void;
    label: string;
};

export const AbsenceTypePicker: React.FC<AbsenceTypePickerProps> = ({ value, onChange, label }) => {
    const intl = useIntl();
    const selectedBg = useColorModeValue('yellow.50', 'yellow.900');
    const defaultBg = useColorModeValue('gray.50', 'gray.700');
    const selectedBorder = useColorModeValue('yellow.400', 'yellow.500');
    const defaultBorder = useColorModeValue('gray.200', 'gray.600');
    const selectedColor = useColorModeValue('yellow.700', 'yellow.300');
    const defaultColor = useColorModeValue('gray.600', 'gray.400');

    return (
        <FormControl width={'100%'}>
            <FormLabel>{label}</FormLabel>
            <SimpleGrid columns={2} spacing={2}>
                {Object.values(AbsenceType).map((type) => {
                    const selected = value === type;
                    return (
                        <Box
                            key={type}
                            as="button"
                            type="button"
                            onClick={() => onChange(type)}
                            display="flex"
                            flexDir="row"
                            alignItems="center"
                            gap={2}
                            px={3}
                            py={3}
                            borderRadius="lg"
                            borderWidth={selected ? 2 : 1}
                            borderColor={selected ? selectedBorder : defaultBorder}
                            bg={selected ? selectedBg : defaultBg}
                            color={selected ? selectedColor : defaultColor}
                            fontWeight={selected ? 600 : 400}
                            fontSize="sm"
                            textAlign="left"
                            transition="all 0.15s"
                            _hover={{ borderColor: selectedBorder }}
                        >
                            <Icon as={absenceTypeIconMap[type]} boxSize={5} flexShrink={0} />
                            <Text fontSize="sm" fontWeight={selected ? 600 : 400} noOfLines={2}>
                                {intl.formatMessage({ id: `absence.type.${type}` })}
                            </Text>
                        </Box>
                    );
                })}
            </SimpleGrid>
        </FormControl>
    );
};
